import request from '@/config/request.js'
import setting from '@/config/settings'
import { Message } from 'element-ui'

import Modules from '@/components/modules'
import RouteView from '@/components/routeView'
// import store from "@/store";
const ApiLogin = request.UserLogin
const DoubleTeacher = request.DoubleTeacher;
export default {
  name: 'login',
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        if (this.resetlogin.confirmPassword !== '') {
          this.$refs.resetPass.validateField('confirmPassword')
        }
        callback()
      }
    }
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请重复输入新密码'))
      } else if (value !== this.resetlogin.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      qiniu: setting.gbs.qiniu,
      login: {
        mobile: this.$store.state.login.logininfo.loginName,
        password: this.$store.state.login.logininfo.loginPwd,
        validCodeKey: '',
        validCodeValue: '',
        rememberMe: false
      },
      resetlogin: {
        mobile: '',
        newPassword: '',
        confirmPassword: '',
        code: ''
      },
      loginRules: {
        mobile: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        validCodeValue: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      checked: true,
      codeChange: '',
      changeTeacher: false,
      changeTeacherList: [],
      appUrl: setting.gbs.host,
      changeItem: '',
      teacherID: '',
      codeUrl: '',
      loginType: 'pass',
      number: localStorage.getItem('bell-min') ? localStorage.getItem('bell-min') : -1,
      resetnumber: localStorage.getItem('bell-reset-min') ? localStorage.getItem('bell-reset-min') : -1,
      resetPassDialog: false,
      loginSubmitting: false,
      passRules: {
        mobile: [
          { required: true, message: '请输入新账号', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ]
      },
      shuangShiMenu: {
        "id": "90",
        "parentId": "0",
        "name": "全能双师",
        "path": "/double-teacher",
        "icon": "bell-icon-shuangshiketang",
        "component": "RouteView.RouteIndex.Index",
        "keepAlive": false,
        "singleMenu": false,
        "sort": 16,
        "isShow": true,
        "children": [
          {
            "id": "91",
            "parentId": "90",
            "name": "双师账号",
            "path": "/accountManagement",
            "component": "Modules.DoubleTeacher.accountManagement",
            "keepAlive": false,
            "singleMenu": false,
            "sort": 17,
            "isShow": true
          },
          {
            "id": "92",
            "parentId": "90",
            "name": "账号权限",
            "path": "/accountPermission",
            "component": "Modules.DoubleTeacher.accountPermission",
            "keepAlive": false,
            "singleMenu": false,
            "sort": 17,
            "isShow": true
          },
          {
            "id": "93",
            "parentId": "90",
            "name": "班级管理",
            "path": "/classManagement",
            "component": "Modules.DoubleTeacher.classManagement",
            "keepAlive": false,
            "singleMenu": false,
            "sort": 17,
            "isShow": true
          },
          {
            "id": "94",
            "parentId": "93",
            "name": "班级课程表",
            "path": "/classManagement/timeTable",
            "component": "Modules.DoubleTeacher.timeTable",
            "keepAlive": false,
            "singleMenu": false,
            "sort": 17,
            "isShow": false
          },
          {
            "id": "95",
            "parentId": "93",
            "name": "班级学期课程表",
            "path": "/classManagement/timeTablePeriod",
            "component": "Modules.DoubleTeacher.timeTablePeriod",
            "keepAlive": false,
            "singleMenu": false,
            "sort": 17,
            "isShow": false
          },
          {
            "id": "96",
            "parentId": "93",
            "name": "班级周课程表",
            "path": "/classManagement/timeTableWeek",
            "component": "Modules.DoubleTeacher.timeTableWeek",
            "keepAlive": false,
            "singleMenu": false,
            "sort": 17,
            "isShow": false
          },
        ]
      }
    }
  },
  computed: {
    loading: function () {
      return this.$store.state.global.ajax_loading
    },
    submitLoading: function () {
      return Boolean(this.loading || this.loginSubmitting)
    }
  },
  methods: {
    isPasswordCompliant(pwd) {
      const s = String(pwd == null ? '' : pwd)
      if (s.length < 8) return false
      if (!/[A-Za-z]/.test(s)) return false
      if (!/\d/.test(s)) return false
      return true
    },
    setLoginPwdPolicyState(type, password) {
      const prefix = setting && setting.gbs && setting.gbs.db_prefix
        ? setting.gbs.db_prefix
        : 'bell_admin_'
      localStorage.setItem(prefix + 'login_type', type)
      if (type === 'code') {
        localStorage.removeItem('bell_admin_pwd_force_change')
        return
      }
      if (this.isPasswordCompliant(password)) {
        localStorage.removeItem('bell_admin_pwd_force_change')
      } else {
        localStorage.setItem('bell_admin_pwd_force_change', '1')
      }
    },
    // 重置密码
    onResetPassWord(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          ApiLogin.resetPassword.call(this, { mobile: this.resetlogin.mobile, password: this.resetlogin.newPassword, authCode: this.resetlogin.code }, item => {
            this.resetnumber = -1
            this.resetPassDialog = false
            Message({
              message: item.result,
              type: 'success'
            })
          })
        }
      })
    },
    onChangeLoginType(type) {
      this.loginType = type
      const formRef = this.$refs && this.$refs.loginruleForm ? this.$refs.loginruleForm : null
      if (formRef && typeof formRef.clearValidate === 'function') {
        formRef.clearValidate()
      }
    },
    componentsMatch(array) {
      return new Promise((resolve) => {
        let arr = []
        arr = array.filter(item => {
          if (Object.prototype.hasOwnProperty.call(item, 'children')) {
            const list = item.component.split('.')
            let module = ''
            if (item.component.indexOf('RouteView') > -1) {
              for (let i = 1; i < list.length; i++) {
                module = module ? module[list[i]] : RouteView[list[i]]
              }
            } else if (item.component.indexOf('Modules') > -1) {
              for (let i = 1; i < list.length; i++) {
                module = module ? module[list[i]] : Modules[list[i]]
              }
            }
            item.component = module
            item.children.filter((it) => {
              const childComponent = it.component.split('.')
              let childmodule = ''
              if (it.component.indexOf('RouteView') > -1) {
                for (let i = 1; i < childComponent.length; i++) {
                  childmodule = childmodule ? childmodule[childComponent[i]] : RouteView[childComponent[i]]
                }
              } else if (it.component.indexOf('Modules') > -1) {
                for (let i = 1; i < childComponent.length; i++) {
                  childmodule = childmodule ? childmodule[childComponent[i]] : Modules[childComponent[i]]
                }
              }
              it.component = childmodule
            })
          }
          return item
        })
        resolve(arr)
      })
    },
    resolveRouteComponent(componentPath) {
      if (!componentPath) return ''
      if (typeof componentPath !== 'string') return componentPath
      const parts = componentPath.split('.')
      if (parts.length < 2) return ''
      let root = ''
      if (parts[0] === 'RouteView') {
        root = RouteView
      } else if (parts[0] === 'Modules') {
        root = Modules
      } else {
        return ''
      }
      let mod = root
      for (let i = 1; i < parts.length; i++) {
        if (!mod) return ''
        mod = mod[parts[i]]
      }
      return mod || ''
    },
    routeMatch(array) {
      return new Promise((resolve) => {
        const list = Array.isArray(array) ? array : []
        const routes = list.map((item) => {
          const module = this.resolveRouteComponent(item && item.component)
          let children = []
          if (item && Array.isArray(item.children) && item.children.length > 0) {
            children = item.children.map((child) => {
              return {
                path: this.getSrtSubstring(child.path),
                name: this.getSrtSubstring(child.path),
                meta: {
                  name: child.name
                },
                component: this.resolveRouteComponent(child.component)
              }
            })
          }
          if (children.length > 0) {
            children = [
              {
                path: '/',
                redirect: () => {
                  const str = children[0].path
                  return str.indexOf('/') > -1 ? str.substr(1) : str
                },
                hidden: true
              },
              ...children
            ]
          }
          return {
            path: item.path,
            meta: {
              name: item.name,
              keepAlive: true
            },
            component: module,
            children,
            name: item.path
          }
        })
        resolve(routes)
      })
    },
    getRouterArray(dataMenu) {
      let arr = []
      if (dataMenu && dataMenu.length < 1) {
        arr = []
      }
      if (dataMenu && dataMenu.length > 0) {
        arr = dataMenu.map(list => {
          return {
            text: list.name,
            icon: list.icon,
            path: list.path,
            isShow: list.isShow,
            component: list.component,
            children: list.children && list.children.map(child => {
              return {
                path: child.path,
                text: child.name,
                isShow: child.isShow,
                component: child.component
              }
            })
          }
        })
      }
      return arr
    },
    /**
     * 统一补齐当前登录校区信息，确保品牌标识在单校区/多校区场景下都可用。
     * @param {Object} zoneTeacher 当前选中的校区老师对象
     * @param {Object} fallbackZoneTeacher 登录接口返回的兜底校区老师对象
     * @returns {Object} 可安全写入 store 的当前校区对象
     */
    buildZoneTeacherForStore(zoneTeacher, fallbackZoneTeacher) {
      const current = zoneTeacher && typeof zoneTeacher === 'object'
        ? Object.assign({}, zoneTeacher)
        : {}
      const fallback = fallbackZoneTeacher && typeof fallbackZoneTeacher === 'object'
        ? fallbackZoneTeacher
        : {}
      const schoolZone = Object.assign(
        {},
        fallback && fallback.schoolZone ? fallback.schoolZone : {},
        current && current.schoolZone ? current.schoolZone : {}
      )
      const brand = schoolZone.zoneBrand || schoolZone.brand || ''
      if (brand) {
        if (!schoolZone.brand) schoolZone.brand = brand
        if (!schoolZone.zoneBrand) schoolZone.zoneBrand = brand
      }
      current.schoolZone = schoolZone
      return current
    },
    /**
     * 将当前登录校区写入 store，供页面跳转和品牌展示复用。
     * @param {Object} loginRes 登录/切换校区接口返回结果
     * @param {Object} zoneTeacher 当前校区老师对象
     * @returns {Object} 当前写入后的校区老师对象
     */
    persistCurrentZone(loginRes, zoneTeacher) {
      const fallbackZoneTeacher = loginRes && loginRes.zoneTeacher
        ? loginRes.zoneTeacher
        : null
      const currentZoneTeacher = this.buildZoneTeacherForStore(
        zoneTeacher,
        fallbackZoneTeacher
      )
      const schoolZone = currentZoneTeacher && currentZoneTeacher.schoolZone
        ? currentZoneTeacher.schoolZone
        : {}
      this.$store.dispatch('setSchoolsInfo', JSON.stringify(loginRes || {}))
      this.$store.dispatch('setZoneId', schoolZone.zoneId || '')
      this.$store.dispatch(
        'setZoneTeacher',
        JSON.stringify(currentZoneTeacher)
      )
      return currentZoneTeacher
    },
    getTeacherLogin(teacher = []) {
      ApiLogin.getTeacherAccountInfoByTeacherId.call(this, { teacherId: teacher[0].teacherId }, item => {
        this.$store.dispatch('setUserInfo', JSON.stringify(item))
        ApiLogin.getMenus.call(this, {}, dataMenu => {
          const menus = Array.isArray(dataMenu) ? dataMenu : []
          this.lingjiaoVerifyAccount((result) => {
            if (result) {
              menus.push(this.shuangShiMenu)
            }
            if (menus.length === 0) {
              Message({
                message: '未分配任何菜单权限，请联系管理员！',
                type: 'error'
              })
            }
            this.setMenu(menus).then(() => {
              this.routeMatch(JSON.parse(this.$store.state.login.rootMenu)).then(rt => {
                this.$router.options.routes = this.$router.options.routes.concat(rt)
                this.$router.addRoutes(rt)
                for (const router in menus) {
                  const children = menus[router] && Array.isArray(menus[router].children)
                    ? menus[router].children
                    : []
                  if (children.length > 0) {
                    this.$nextTick(() => {
                      this.loginSubmitting = false
                      const menuPath = children[0].path
                      const path = menuPath
                      this.$router.push({
                        path: menus[router].path + path
                      })
                    })
                    break
                  } else {
                    this.$nextTick(() => {
                      this.loginSubmitting = false
                      this.$router.push({
                        path: menus[router].path
                      })
                    })
                  }
                }
              })
            })
          });
        }, () => {
          this.loginSubmitting = false
          Message({ message: '获取菜单失败，请重试', type: 'error' })
        })
      }, () => {
        this.loginSubmitting = false
        Message({ message: '获取用户信息失败，请重试', type: 'error' })
      })
    },
    loginIn(loginruleForm) {
      const that = this
      this.$store.dispatch('schoolsTeacher', JSON.stringify([]))
      const mobile = that && that.login ? String(that.login.mobile || '').trim() : ''
      const password = that && that.login ? String(that.login.password || '').trim() : ''
      const authCode = that && that.login ? String(that.login.validCodeValue || '').trim() : ''

      if (!mobile) {
        Message({ message: '请输入账号', type: 'error' })
        return
      }
      if (this.loginType === 'pass') {
        if (!password) {
          Message({ message: '请输入密码', type: 'error' })
          return
        }
      } else {
        if (!authCode) {
          Message({ message: '请输入验证码', type: 'error' })
          return
        }
      }

      const onLoginSuccess = (res) => {
        this.$store.dispatch('loginIn', 'Bearer ' + res.token)
        ApiLogin.listZoneTeacher.call(this, {}, teacher => {
          if (teacher.length > 1) {
            this.$store.dispatch('schoolsTeacher', JSON.stringify(teacher))
            that.changeTeacherList = teacher
            that.changeTeacher = true
            this.loginSubmitting = false
          } else {
            const currentZoneTeacher = this.persistCurrentZone(
              res,
              teacher[0]
            )
            ApiLogin.zoneFeatureIsBroadcast.call(this, {}, item => {
              this.$store.dispatch('setOtoStatus', item)
            })
            this.getTeacherLogin([currentZoneTeacher])
          }
        }, () => {
          this.loginSubmitting = false
          Message({ message: '获取校区信息失败，请重试', type: 'error' })
        })
      }

      if (this.loginType === 'pass') {
        this.loginSubmitting = true
        this.setLoginPwdPolicyState('pass', password)
        this.$store.dispatch('setUserLogin', {
          loginName: mobile,
          loginPwd: password
        })
        ApiLogin.login.call(
          this,
          { mobile, password },
          onLoginSuccess,
          () => {
            this.loginSubmitting = false
          }
        )
      } else {
        this.loginSubmitting = true
        this.setLoginPwdPolicyState('code', '')
        this.$store.dispatch('setUserLogin', {
          loginName: mobile,
          loginPwd: ''
        })
        ApiLogin.loginWithCode.call(
          this,
          { mobile, authCode },
          onLoginSuccess,
          () => {
            this.loginSubmitting = false
          }
        )
      }
    },
    setMenu(menu) {
      return new Promise((resolve) => {
        this.$store.dispatch('setRootMenu', JSON.stringify(menu))
        resolve()
      })
    },
    getSrtSubstring(path) {
      if (path.indexOf('/') > -1) {
        return path.substr(1)
      } else {
        return path
      }
    },
    getTeacher() {
      if (!this.teacherID) {
        Message({
          message: '请选择登录的校区！',
          type: 'error'
        })
        return
      }
      ApiLogin.changeLoginZoneTeacher2.call(this, { zoneTeacherId: this.teacherID }, (res) => {
        this.$store.dispatch('loginIn', 'Bearer ' + res.token)
        const currentZoneTeacher = this.persistCurrentZone(
          res,
          res.zoneTeacher
        )
        this.$nextTick(() => {
          ApiLogin.zoneFeatureIsBroadcast.call(this, {}, item => {
            this.$store.dispatch('setOtoStatus', item)
          })
          ApiLogin.getTeacherAccountInfoByTeacherId.call(this, { teacherId: currentZoneTeacher.teacherId }, item => {
            this.$store.dispatch('setUserInfo', JSON.stringify(item))
            ApiLogin.getMenus.call(this, {}, dataMenu => {
              const menus = Array.isArray(dataMenu) ? dataMenu : []
              this.lingjiaoVerifyAccount((result) => {
                if (result) {
                  menus.push(this.shuangShiMenu)
                }
                if (menus.length === 0) {
                  Message({
                    message: '未分配任何菜单权限，请联系管理员！',
                    type: 'error'
                  })
                }

                this.setMenu(menus).then(() => {
                  this.routeMatch(JSON.parse(this.$store.state.login.rootMenu)).then(rt => {
                    this.$router.options.routes = this.$router.options.routes.concat(rt)
                    this.$router.addRoutes(rt)
                    for (const router in menus) {
                      const children = menus[router] && Array.isArray(menus[router].children)
                        ? menus[router].children
                        : []
                      if (children.length > 0) {
                        this.$nextTick(() => {
                          const menuPath = children[0].path
                          const path = menuPath
                          this.$router.push({
                            path: menus[router].path + path
                          })
                        })
                        break
                      } else {
                        this.$nextTick(() => {
                          this.$router.push({
                            path: menus[router].path
                          })
                        })
                      }
                    };
                  })
                })
              });
            })
          })
        })
      })
    },
    changeRadio(e) {
      this.teacherID = e
    },
    validCodeChange() {
      const randomKey = new Date().getTime() + Math.random()
      this.login.validCodeKey = randomKey
      this.$nextTick(() => {
        this.login.validCodeKey = randomKey
        this.codeUrl = this.appUrl + 'app/rest/school/green/security/validCodeKey?key=' + randomKey
      })
    },
    resetloginValidateCodeByManager(fn) {
      ApiLogin.loginValidateCodeByManager.call(this, { mobile: this.resetlogin.mobile }, item => {
        Message({
          message: item.result,
          type: 'success'
        })
        fn()
      })
    },
    loginValidateCodeByManager(fn) {
      ApiLogin.loginValidateCodeByManager.call(this, { mobile: this.login.mobile }, item => {
        Message({
          message: item.result,
          type: 'success'
        })
        fn()
      })
    },
    changeMine() {
      this.number = this.number - 1
      localStorage.setItem('bell-min', this.number)
    },
    resetChangeMine() {
      this.resetnumber = this.resetnumber - 1
      localStorage.setItem('bell-reset-min', this.resetnumber)
    },
    sendResetCodeChange() {
      const that = this
      if (that.resetnumber > -1) {
        return
      }
      var reg = /^1(3|4|5|6|7|8|9)\d{9}$/
      if (reg.test(that.resetlogin.mobile) === false) {
        Message({
          message: '请输入正确的手机号码',
          type: 'error'
        })
      } else {
        that.resetloginValidateCodeByManager(() => {
          that.resetnumber = 60
          const min = setInterval(function () {
            if (that.resetnumber > -1) {
              that.resetChangeMine()
            } else {
              clearInterval(min)
            }
          }, 1000)
        })
      }
    },
    sendCodeChange() {
      const that = this
      if (that.number > -1) {
        return
      }
      var reg = /^1(3|4|5|6|7|8|9)\d{9}$/
      if (reg.test(that.login.mobile) === false) {
        Message({
          message: '请输入正确的手机号码',
          type: 'error'
        })
      } else {
        that.loginValidateCodeByManager(() => {
          that.number = 60
          const min = setInterval(function () {
            if (that.number > -1) {
              that.changeMine()
            } else {
              clearInterval(min)
            }
          }, 1000)
        })
      }
    },
    lingjiaoVerifyAccount(rtnBack) {
      ApiLogin.lingjiaoVerifyAccount.call(this, {}, res => {
        if (res && res.success) {
          DoubleTeacher.login.call(this, res.data, response => {
            if (response && response.success) {
              this.$store.dispatch('setLingjiaoCurrentUser', JSON.stringify(response.data));
              rtnBack(true);
            } else {
              rtnBack(false);
            }
          });
        } else {
          rtnBack(false);
        }
      });
    }
  },
  mounted() {
    const that = this
    const min = setInterval(function () {
      if (that.number > -1) {
        that.changeMine()
      } else {
        clearInterval(min)
      }
    }, 1000)
    const restMin = setInterval(function () {
      if (that.resetnumber > -1) {
        that.resetChangeMine()
      } else {
        clearInterval(restMin)
      }
    }, 1000)
  }
}
